import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
  MenuItem,
} from "@mui/material";

function CardsTcgdexImportDialog({
  open,
  onClose,
  tcgdexImporting,
  tcgdexMode,
  setTcgdexMode,
  tcgdexPickerSeriesId,
  setTcgdexPickerSeriesId,
  tcgdexPickerSetId,
  setTcgdexPickerSetId,
  tcgdexSetsRows,
  tcgdexSetsLoading,
  tcgdexSetsError,
  getUniqueSeriesOptions,
  getFilteredSetOptions,
  ensureTcgdexSetsLoaded,
  tcgdexSetId,
  setTcgdexSetId,
  tcgdexSetName,
  setTcgdexSetName,
  tcgdexCardId,
  setTcgdexCardId,
  tcgdexError,
  tcgdexResult,
  onRunImport,
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Import from TCGdex</DialogTitle>
      <DialogContent>
        <div style={{ display: "flex", flexDirection: "column", gap: 8, marginTop: 8 }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={tcgdexMode === "picker"}
                onChange={() => {
                  setTcgdexMode("picker");
                  ensureTcgdexSetsLoaded();
                }}
              />
            }
            label="Pick Series + Set (recommended)"
          />
          {tcgdexMode === "picker" ? (
            <>
              <TextField
                select
                label="Series"
                value={tcgdexPickerSeriesId}
                onChange={(e) => {
                  setTcgdexPickerSeriesId(e.target.value);
                  setTcgdexPickerSetId("");
                }}
                fullWidth
              >
                <MenuItem value="">
                  (All / Unknown)
                </MenuItem>
                {getUniqueSeriesOptions().map((s) => (
                  <MenuItem key={s.series_id} value={s.series_id}>
                    {s.series_name}
                  </MenuItem>
                ))}
              </TextField>

              <TextField
                select
                label="Set"
                value={tcgdexPickerSetId}
                onChange={(e) => setTcgdexPickerSetId(e.target.value)}
                fullWidth
                disabled={!tcgdexSetsRows || tcgdexSetsRows.length === 0}
                helperText={tcgdexSetsLoading ? "Loading sets..." : ""}
              >
                {getFilteredSetOptions(tcgdexPickerSeriesId).map((s) => (
                  <MenuItem key={s.set_id} value={s.set_id}>
                    {s.set_name}
                  </MenuItem>
                ))}
              </TextField>

              {tcgdexSetsError ? (
                <div style={{ color: "#d32f2f", marginTop: 4 }}>
                  {tcgdexSetsError.error || tcgdexSetsError.message || "Failed to load sets"}
                </div>
              ) : null}
            </>
          ) : null}

          <FormControlLabel
            control={
              <Checkbox
                checked={tcgdexMode === "set_id"}
                onChange={() => setTcgdexMode("set_id")}
              />
            }
            label='Set ID (e.g. "me02.5")'
          />
          {tcgdexMode === "set_id" ? (
            <TextField
              label="Set ID"
              value={tcgdexSetId}
              onChange={(e) => setTcgdexSetId(e.target.value)}
              fullWidth
            />
          ) : null}

          <FormControlLabel
            control={
              <Checkbox
                checked={tcgdexMode === "set_name"}
                onChange={() => setTcgdexMode("set_name")}
              />
            }
            label='Set Name (e.g. "Ascended Heroes")'
          />
          {tcgdexMode === "set_name" ? (
            <TextField
              label="Set Name"
              value={tcgdexSetName}
              onChange={(e) => setTcgdexSetName(e.target.value)}
              fullWidth
            />
          ) : null}

          <FormControlLabel
            control={
              <Checkbox
                checked={tcgdexMode === "card_id"}
                onChange={() => setTcgdexMode("card_id")}
              />
            }
            label='Single Card ID (e.g. "me02.5-001")'
          />
          {tcgdexMode === "card_id" ? (
            <TextField
              label="Card ID"
              value={tcgdexCardId}
              onChange={(e) => setTcgdexCardId(e.target.value)}
              fullWidth
            />
          ) : null}

          {tcgdexError ? (
            <div style={{ color: "#d32f2f", marginTop: 8 }}>
              {tcgdexError.error || tcgdexError.message || "Import failed"}
            </div>
          ) : null}

          {tcgdexResult ? (
            <div style={{ color: "#2e7d32", marginTop: 8 }}>
              Imported. Processed: {tcgdexResult.processed} • Inserted: {tcgdexResult.inserted}
              {tcgdexResult.set_name ? ` • Set: ${tcgdexResult.set_name}` : ""}
            </div>
          ) : null}
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={tcgdexImporting}>
          Cancel
        </Button>
        <Button
          onClick={onRunImport}
          variant="contained"
          disabled={tcgdexImporting}
        >
          {tcgdexImporting ? "Running..." : "Run Import"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default CardsTcgdexImportDialog;
